import { render, staticRenderFns } from "./createPedidos.vue?vue&type=template&id=20cb79dd&scoped=true&"
import script from "./createPedidos.vue?vue&type=script&lang=js&"
export * from "./createPedidos.vue?vue&type=script&lang=js&"
import style0 from "./createPedidos.vue?vue&type=style&index=0&id=20cb79dd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20cb79dd",
  null
  
)

export default component.exports